import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

const ContactFields = (_props, context) => {
  const { control, errors } = useFormContext();

  return (
    <>
      <Row>
        <Col>
          <FormGroup>
            <Label for="firstName">{context.t("First Name")}</Label>
            <Controller
              name="firstName"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="firstName"
                  autocomplete="given-name"
                  type="text"
                  {...field}
                />
              )}
            />

            {errors.firstName && (
              <span role="alert" className="small text-danger">
                {errors.firstName.message}
              </span>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="lastName">{context.t("Last Name")}</Label>
            <Controller
              name="lastName"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="lastName"
                  autocomplete="family-name"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors.lastName && (
              <span role="alert" className="small text-danger">
                {errors.lastName.message}
              </span>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label for="streetAddress">{context.t("Address")}</Label>
            <Controller
              name="streetAddress"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="streetAddress"
                  autocomplete="street-address"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors.streetAddress && (
              <span role="alert" className="small text-danger">
                {errors.streetAddress.message}
              </span>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label for="zipCode">{context.t("ZIP or postal code")}</Label>
            <Controller
              name="zipCode"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="zipCode"
                  autocomplete="postal-code"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors.zipCode && (
              <span role="alert" className="small text-danger">
                {errors.zipCode.message}
              </span>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="city">City</Label>
            <Controller
              name="city"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="city"
                  autocomplete="address-level2"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors.city && (
              <span role="alert" className="small text-danger">
                {errors.city.message}
              </span>
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label for="country">{context.t("Country")}</Label>
            <Controller
              name="country"
              control={control}
              rules={{ required: { value: true, message: "is required" } }}
              render={({ field }) => (
                <Input
                  id="country"
                  autocomplete="country"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors.country && (
              <span role="alert" className="small text-danger">
                {errors.country.message}
              </span>
            )}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

ContactFields.contextTypes = {
  t: PropTypes.func,
};

ContactFields.propTypes = {};

ContactFields.defaultProps = {};

export default ContactFields;
